export var USER_TYPE_ADMIN = 'ADMIN';
export var USER_TYPE_FACILITATOR = 'FACILITATOR';
export var USER_TYPE_USER = 'USER';
